import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { Category } from '../models';
import { CategoryActions, CategoryActionTypes } from '../actions';

export interface CategoryState extends EntityState<Category> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<Category> = createEntityAdapter<Category>({
  selectId: (category) => category.id,
});

export const initialCategoryState: CategoryState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function categoryReducer(
  state = initialCategoryState,
  action: CategoryActions,
): CategoryState {
  switch (action.type) {
    case CategoryActionTypes.ToggleCategoryPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case CategoryActionTypes.ToggleCategoryActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case CategoryActionTypes.LoadCategoryPage:
      return adapter.addMany(action.payload.categories, {
        ...initialCategoryState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case CategoryActionTypes.CancelCategoryPage:
      return { ...state, query: new QueryParamsModel({}) };

    case CategoryActionTypes.CreateCategory:
      return adapter.addOne(action.payload.category, state);

    case CategoryActionTypes.UpdateCategory:
      return adapter.updateOne(action.payload.category, state);

    case CategoryActionTypes.ThrowCategoryError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case CategoryActionTypes.ClearCategoryError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
